<template>
<b-row class="ot-main-panel no-gutters">
    <b-col>
        <h1>Page Not Found</h1>
        <p>
            The page you requested was not found.
        </p>
    </b-col>
</b-row>
</template>

<script>

export default {

    mounted() {
        this.$store.commit('breadcrumbs', [{
            name: 'pageNotFound',
            meta: { label: 'Page Not Found' }
        }]);
    }
}
</script>
